import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=0353c421&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"
import style0 from "./Demand.vue?vue&type=style&index=0&id=0353c421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353c421",
  null
  
)

export default component.exports